/**
 * BCP固定セクションの定数定義
 *
 * フロントエンドとバックエンドで同じ固定文言を使用するセクションを一元管理します。
 * これらのセクションはAI生成ではなく、事前に定義された固定テンプレートを使用します。
 */

export const BCP_FIXED_SECTIONS = {
  /**
   * 4-1. BCP発動の判断基準
   * 簡易版BCPで使用される固定の発動基準
   */
  ACTIVATION_CRITERIA_4_1: `危機事象の顕在化により、通常のオペレーションでは目標復旧時間内での復旧が困難となる可能性が発生した場合。
但し、震度6弱以上の地震が発生した場合は自動発動とする。`,

  /**
   * 3-3. 資金計画
   * 財務状況の把握と資金調達先の固定テンプレート
   */
  FINANCIAL_PLAN_3_3: `・資金繰りを定期的に確認し、緊急時に利用可能な資金を確保する。
・地元金融機関、取引銀行、政府系金融機関（日本政策金融公庫など）との連携を強化し、緊急時に迅速な資金調達ができる体制を整備する。
・地元商工会議所、金融機関担当者、専門コンサルタントに相談し、資金計画を定期的に見直す。`,

  /**
   * 5-1. 緊急対応フロー（初動対応）
   * 地震・水害・感染症別の初動対応フロー
   */
  EMERGENCY_RESPONSE_5_1: `【地震】
ステージ1（発災・BCP発動フェーズ）：安全確保、家族との連絡確保、社員の安否確認実施、対策本部設置
ステージ2（事業再開フェーズ）：情報集約（社員の出社可否・自社資源の使用可否）、自社事業への影響分析
ステージ3（業務回復フェーズ）：重要業務を現地復旧（困難な場合は、現地復旧以外の戦略）
ステージ4（全面回復フェーズ）：全業務の順次回復
【水害】
ステージ1（自然災害の発生）：情報収集、避難場所の確認や周知、備蓄品の点検
ステージ2（地域で被害の恐れ）：対策本部設置、浸水防止・設備保護対応、テレワークの準備
ステージ3（事業所で被害の恐れ）：避難実施、出社制限、状況に応じて業務の一時停止や縮小
ステージ4（事業所で被害が発生）：被害情報等情報集約、状況に応じて重要業務以外の業務停止
ステージ5（深刻な被害が発生）：重要業務を現地復旧（困難な場合は、現地復旧以外の戦略）
ステージ6（終息段階）：全業務の順次回復
【感染症】
ステージ1（海外発生）：情報収集、備蓄品の点検、感染防止行動の周知、対策本部設置
ステージ2（国内発生）：不要不急の外出自粛、シフト勤務やテレワークの準備
ステージ3（地域発生）：テレワークや出社制限の実施、重要業務は原則遂行
ステージ4（感染発生）：事業所内での感染拡大防止措置、重要業務以外は状況に応じて業務の一時停止や縮小
ステージ5（感染拡大）：感染状況集約、重要業務以外の業務は原則禁止
ステージ6（終息期）：全業務の順次回復`,

  /**
   * 5-2. 対策本部の立ち上げ
   * 対策本部の構成メンバーと役割分担
   */
  ROLES_RESPONSIBILITIES_5_2: `本部長：{役職名を入力}
【初期対応チーム】
・メンバー：{役職名を入力}
・役割：安否情報集約、各設備の被害状況集約、従業員の対応計画、負傷者対応
【復旧対応チーム】
・メンバー：{役職名を入力}
・役割：重要事業の実施体制検討、システム状況対応、資金繰り管理、各種情報収集（災害情報、協力会社、他社の状況等）、情報発信`,

  /**
   * 5-3. 緊急時の連絡手段
   * 従業員間の連絡方法
   */
  COMMUNICATION_METHODS_5_3: `従業員間の連絡方法:
・電話: 緊急連絡網を整備し、原則、電話での情報伝達とする
・メール: 全従業員のメールアドレスを事前に登録し、一斉送信で情報共有を行う。
・SNS（LINE等）: 緊急時専用のグループを作成し、リアルタイムで情報を共有する。
・その他: 必要に応じてFAXや社内掲示板を活用。`,

  /**
   * 6-1. 定期訓練
   * 訓練計画と実施頻度
   */
  REGULAR_TRAINING_6_1: `訓練内容と実施時期
・避難訓練: 年1回（9月）実施。避難経路の確認と集合場所での点呼を行う。`,

  /**
   * 6-2. BCPの定期見直し
   * 見直しルールと更新頻度
   */
  BCP_REVIEW_6_2: `見直しルール
・見直し頻度: 年1回（毎年10月）に実施。
・見直し内容: 最新のリスク情報を反映し、訓練や実際の災害対応で判明した課題を改善する。
・責任者: 責任者を任命し、各部門からの意見を収集して改訂案を作成する。`,

  /**
   * 6-3. 従業員教育
   * 教育・研修計画
   */
  EMPLOYEE_EDUCATION_6_3: `毎年4月に以下の従業員教育を実施する。
【全社員向け基礎教育】
・年1回、全社員を対象にBCPの概要と緊急時の対応手順を再確認する。
【管理職向け研修】
・年1回、管理職を対象に指揮命令系統や役割分担を中心とした研修を実施する。
【専門教育】
・必要に応じて外部講師を招き、専門的な災害対応スキルを習得する研修を実施する。
【マルチスキル化】
・従業員に複数業務を担えるスキルを習得させる。
・人員不足時でも業務を継続できる体制を確保する。`,
} as const;

/**
 * セクションIDから固定セクションを取得するヘルパー関数
 */
export const getFixedSectionContent = (sectionId: string): string | null => {
  const sectionMap: Record<string, keyof typeof BCP_FIXED_SECTIONS> = {
    'activationCriteria': 'ACTIVATION_CRITERIA_4_1',
    'financialPlan': 'FINANCIAL_PLAN_3_3',
    'emergencyOrganization': 'EMERGENCY_RESPONSE_5_1',
    'rolesResponsibilities': 'ROLES_RESPONSIBILITIES_5_2',
    'communicationMethods': 'COMMUNICATION_METHODS_5_3',
    'regularTraining': 'REGULAR_TRAINING_6_1',
    'bcpReview': 'BCP_REVIEW_6_2',
    'employeeEducation': 'EMPLOYEE_EDUCATION_6_3',
  };

  const key = sectionMap[sectionId];
  return key ? BCP_FIXED_SECTIONS[key] : null;
};
